import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'

import SimpleTableHeader from 'components/table/SimpleTableHeader'

import FolderPathTitle from './FolderPathTitle'
import OptionsButton from './OptionsButton'

import icons from 'settings/icons'

const DeleteIcon = icons.delete
const TaskIcon = icons.task
const FolderIcon = icons.folder

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(),
  },
  toolbar: {
    paddingLeft: '0px',
    paddingRight: '0px',
  },
  mainButtons: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  mainButtonsSplitter: {
    width: theme.spacing(),
  },
  folderTextField: {
    width: '100%',
  },
  checkboxLabel: {
    whiteSpace: 'nowrap',
  },
  button: {
    whiteSpace: 'nowrap',
    textTransform: 'none',
    color: theme.palette.grey[700],
    marginRight: theme.spacing(1),
  },
}))

const QuoteHeader = ({
  currentFolder,
  sortMode,
  readOnly,
  clientView,
  route,
  quote,
  folderid,
  folderPath,
  onViewFolder,
  onAddItem,
  onOpenTaskWindow,
  onOpenDeleteWindow,
  onExpandChildren,
  onContractChildren,
  onSetSortMode,
  onSetClientView,
  onExportPDF,
}) => {

  const classes = useStyles()
  const onAddTask = () => onOpenTaskWindow(currentFolder.id)
  const onAddFolder = () => onAddItem({
    parent: currentFolder.id,
    type: 'folder',
    resource: {
      type: 'folder',
      name: 'New Folder',
    }
  })
  const onDelete = () => onOpenDeleteWindow(currentFolder)

  const getButtons = () => {

    return (
      <div className={ classes.mainButtons }>
        <FormControlLabel
          control={
            <Checkbox
              checked={ clientView }
              onChange={ (event) => onSetClientView(event.target.checked) }
              value="yes"
            />
          }
          label="client view"
          classes={{
            label: classes.checkboxLabel,
          }}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={ sortMode }
              onChange={ (event) => onSetSortMode(event.target.checked) }
              value="yes"
            />
          }
          label="sort mode"
          classes={{
            label: classes.checkboxLabel,
          }}
        />
        
        {
          currentFolder.type == 'folder' && (
            <>
              <Button
                className={ classes.button }
                variant="outlined"
                size="small"
                disabled={ readOnly || clientView ? true : false }
                onClick={ onAddTask }
              >
                Add Task&nbsp;&nbsp;<TaskIcon />
              </Button>
              <Button
                className={ classes.button }
                variant="outlined"
                size="small"
                disabled={ readOnly || clientView ? true : false }
                onClick={ onAddFolder }
              >
                Add Folder&nbsp;&nbsp;<FolderIcon />
              </Button>
            </>
          )
        }
        {
          currentFolder.id != 'root' && (
            <Button
              className={ classes.button }
              variant="outlined"
              size="small"
              disabled={ readOnly || clientView ? true : false }
              onClick={ onDelete }
            >
              Delete&nbsp;&nbsp;<DeleteIcon />
            </Button>
          )
        }
        
        <OptionsButton
          large
          topLevel
          readOnly={ readOnly }
          sortMode={ sortMode }
          item={ currentFolder }
          onAddItem={ onAddItem }
          onOpenTaskWindow={ onOpenTaskWindow }
          onOpenDeleteWindow={ onOpenDeleteWindow }
          onExpandChildren={ onExpandChildren }
          onContractChildren={ onContractChildren }
          onExportPDF={ onExportPDF }
        />
      </div>
    )
  }

  return (
    <div className={ classes.root }>
      <SimpleTableHeader
        className={ classes.toolbar }
        title={(
          <FolderPathTitle
            quote={ quote }
            folderid={ folderid }
            folderPath={ folderPath }
            onView={ onViewFolder }
          />
        )}
        getActions={ getButtons }
      />
    </div>
  )
}

export default QuoteHeader